import { Injectable, inject } from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, UrlTree} from '@angular/router';
import { AuthorizationService } from '@services/authorization/authorization.service';
import {Permission} from "@shared/models/settings/role-authorisation";

@Injectable({
    providedIn: 'root'
})
export class RouteAccessGuard  {
    private readonly service = inject(AuthorizationService);

    canActivateChild(childRoute: ActivatedRouteSnapshot): Promise<boolean | UrlTree> {
        return this.hasAccess(childRoute);
    }

    private hasAccess(route: ActivatedRouteSnapshot): Promise<boolean> {
        return new Promise((resolve) => {
            console.log('route data', route.url, route.data);
            const module = route.data['module'];
            /**
             * Minimal permission level is READ unless it is defined on the route
             */
            const permission = route.data['permission'] || 'READ';
            if (!module) {
                return resolve(true);
            }

            if (module === 'SYSOPS') {
                return resolve(this.service.isSysOp);
            }

            console.log('hasAccess', module, permission);

            resolve(this.service.hasComponentAccess(module, permission));
        });
    }
}

@Injectable({ providedIn: 'root' })
export class SignRequestDefaultGuard implements CanActivate {
    private readonly router = inject(Router);
    private readonly service = inject(AuthorizationService);

    async canActivate(): Promise<UrlTree> {
        const options = [
            { path: 'sign-request/open',      module: 'OPEN_DOCUMENTS',      permission: 'READ' as Permission },
            { path: 'sign-request/processed', module: 'PROCESSED_DOCUMENTS', permission: 'READ' as Permission },
            { path: 'sign-request/submitted', module: 'SUBMITTED_DOCUMENTS', permission: 'READ' as Permission },
            { path: 'sign-request/received',  module: 'RECEIVED_DOCUMENTS',  permission: 'READ' as Permission },
            { path: 'sign-request/request',   module: 'SIGNREQUEST',         permission: 'READ' as Permission },
            { path: 'edelivery/open',         module: 'EDELIVERY',           permission: 'READ' as Permission },
        ];

        for (const option of options) {
            if (await this.service.hasComponentAccess(option.module, option.permission)) {
                return this.router.createUrlTree([option.path]);
            }
        }

        return this.router.createUrlTree(['/profile']);
    }
}
